/**
 * Created by lu on 2018/4/16.
 */
var nb = require('../../../nb');
var getOrderList = require('../../../io/' + process.env.APP_ENV + '/order/getOrderList');  //订单列表
var getDeleteOrder = require('../../../io/' + process.env.APP_ENV + '/order/deleteOrder');  //删除订单
var confirmGoods = require('../../../io/' + process.env.APP_ENV + '/order/confirmGoods');  //确认收货
// var cancelOrder = require('../../../io/' + process.env.APP_ENV + '/order/cancelOrder');  //取消订单
module.exports = nb.define({
    parent: require('../../../model/tab/TapWrap'),
    mapping: {
        tabList: require('../../../model/tab/TabList'),
        orderScreen: require('./OrderScreen'),
        orderList: require('./OrderList'),
        orderNav: nb.Model
    },
    method: {
        init: function () {
            var orderScreen = this.get('orderScreen');
            var orderList = this.get('orderList');

            nb.model.onChange(nb.model.user, function (inEvent, inUser) {
                this._userId = parseInt(inUser.get('userId'));
                this._companyId = parseInt(inUser.get('companyId'));
                this.onChange('requireData', function (inEvent, inStatus) {
                    this.set('tabStatus', inStatus);
                    this._getOrderList({
                        status: inStatus,
                        processor: function () {
                            nb.model.set('dataReady', 'data-ready');
                        }
                    });
                }, this);
            }, this);

            //翻页
            orderList.onChange('requirePage', function (inEvent, inPageNo) {
                this._getOrderList({
                    pageNo: inPageNo
                });
            }, this);

            //订单操作按钮
            this.onChange('statusMap', function (inEvent, inMap) {
                nb.model.set('statusMap', inMap);
            }, this);

            //取消订单
            this.onChange('requireCancelOrder', function (inEvent, inIndex) {
                var itemModel = orderList.get('list')._getItemModel(inIndex);
                var id = itemModel.get('id');    //订单id
                this._cancelOrderPopup(id);
            }, this);

            //申请退货
            this.onChange('requireReturnGoodsOrder', function (inEvent, inIndex) {
                var itemModel = orderList.get('list')._getItemModel(inIndex);
                var id = itemModel.get('id');    //订单id
                this._returnGoods(id);
            }, this);

            //立即付款
            this.onChange('requireToPay', function (inEvent, inIndex) {
                // var id = this._companyId;
                var itemModel = orderList.get('list')._getItemModel(inIndex);
                var id = itemModel.get('id');    //订单id
                setTimeout(function () {
                    window.location.href = 'orderPay.html?id=' + id;
                }, 2000);
            }, this);

            //删除订单
            this.onChange('requireDeleteOrder', function (inEvent, inIndex) {
                var itemModel = orderList.get('list')._getItemModel(inIndex);
                var id = itemModel.get('id');    //订单id
                this._deleteOrder(id);
            }, this);

            //确认收货
            this.onChange('requireConfirmGoodsOrder', function (inEvent, inIndex) {
                var itemModel = orderList.get('list')._getItemModel(inIndex);
                var id = itemModel.get('id');    //订单id
                this._confirmGoods(id);
            }, this);

            //查看物流 set状态
            this.onChange('requireSeeLogistics', function (inEvent, inIndex) {
                var logisticsModal = require('../../../model/modal/Logistics'); //查看物流modal
                var itemModel = orderList.get('list')._getItemModel(inIndex);
                var status = itemModel.get('status');
                logisticsModal.set('show', status);
            }, this);

            //点击搜索订单  单号／产品名／时间
            this.onChange('requireScreenOrder', function () {
                var val1 = orderScreen.get('productName').get('value') || '';
                var val2 = orderScreen.get('orderNum').get('value') || '';
                var val3 = orderScreen.get('date1').get('value') || '';
                var val4 = orderScreen.get('date2').get('value') || '';
                var opt = {
                    name: val1,
                    orderNum: val2,
                    startTime: val3,
                    endTime: val4
                };
                this._getOrderList(opt);
            }, this);

            //取消订单成功
            nb.model.onChange('cancelOrderSucceedState', function (inEvent, inData) {
                nb.toast.setOpts({
                    text: inData,
                    status: 'success',
                    duration: 1
                });
                this._getOrderList();
            }, this);

            //申请退货
            nb.model.onChange('returnOrderSucceedState', function (inEvent, inData) {
                nb.toast.setOpts({
                    text: inData,
                    status: 'success',
                    duration: 1
                });
                this._getOrderList();
            }, this);
        },

        //订单列表
        _getOrderList: function (inOpts) {
            var self = this;
            this.set('dataReady', '');
            var opts = inOpts || {};
            getOrderList({
                data: {
                    userId: this._userId,
                    flag: 1, //1为订单调用, 2位开具发票调用
                    name: opts.name || null,
                    companyId: this._companyId,
                    orderNum: opts.orderNum || null,
                    startTime: opts.startTime || null,
                    endTime: opts.endTime || null,
                    type: this.get('tabStatus'), // status
                    pageNo: opts.pageNo || 1   //1
                },
                scope: this,
                success: function (inResp) {
                    this.setOpts({
                        orderList: {
                            data: inResp
                        }
                    });
                },
                always: function () {
                    if (inOpts && inOpts.processor) {
                        inOpts.processor();
                    }
                    self.set('dataReady', 'data-ready');
                }
            });
        },

        //取消订单
        _cancelOrderPopup: function (inId) {
            var CancelOrderModel = require('../../../model/modal/CancelOrder'); //取消订单modal
            nb.model.set('goCancelOrderId', inId);
            CancelOrderModel.set('show', true);// new Date()
        },

        //申请退货
        _returnGoods: function (id) {
            var returnGoodsModal = require('../../../model/modal/returnGoods'); //申请退货modal
            nb.model.set('requireReturnGoodsId', id);
            returnGoodsModal.set('show', true);//new Date()
        },

        //删除订单
        _deleteOrder: function (id) {
            var confirmModel = require('../../../model/modal/Confirm');
            confirmModel.setOpts({
                text: {
                    cn: {
                        text: '您确定要删除订单吗？'
                    },
                    en: {
                        text: 'Are you sure you want to delete the order ？'
                    }
                },
                show: true,
                processor: {
                    scope: this,
                    confirm: function () {
                        getDeleteOrder({
                            data: {
                                userId: this._userId,
                                companyId: this._companyId,
                                orderId: id
                            },
                            scope: this,
                            success: function (inResp) {
                                this._getOrderList();
                            }
                        });
                    }
                }
            });

        },

        //确认收货
        _confirmGoods: function (id) {
            var confirmModel = require('../../../model/modal/Confirm');
            confirmModel.setOpts({
                text: {
                    cn: {
                        text: '您要确认收货吗？'
                    },
                    en: {
                        text: 'Would you like to confirm receipt ？'
                    }
                },
                show: true,
                processor: {
                    scope: this,
                    confirm: function () {
                        confirmGoods({
                            data: {
                                userId: this._userId,
                                companyId: this._companyId,
                                orderId: id
                            },
                            scope: this,
                            success: function (inResp) {
                                this._getOrderList();
                            }
                        });
                    }
                }
            });

        }
    }
});

//点击回收站
// this.onChange('requireRecycle', function () {
//     this._getOrderList()
// }, this);



//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/model/Content.js
// module id = 678
// module chunks = 3